import { render, staticRenderFns } from "./TableRiskAppraisal589.vue?vue&type=template&id=555a5b4f&scoped=true"
import script from "./TableRiskAppraisal589.vue?vue&type=script&lang=js"
export * from "./TableRiskAppraisal589.vue?vue&type=script&lang=js"
import style0 from "./TableRiskAppraisal589.vue?vue&type=style&index=0&id=555a5b4f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555a5b4f",
  null
  
)

export default component.exports